import React from "react"
import "./SkipToContent.scss"

const SkipToContent = () => {
  return (
    //TODO: Render 'Skip to content' label from Contenful label ...
    //...list instead of hard coding it for translation purposes.
    <a className="skip-to-content" href="#page-content">
      Skip to content
    </a>
  )
}

export default SkipToContent
